// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"9ae9838f","126":"ca85e1a1","254":"b7fe1a58","360":"f69abd44","372":"98f2c8cf","538":"9ae9838f","815":"9ae9838f","855":"489e73a0"}[chunkId] + ".chunk.css";
};